module.exports = __webpack_public_path__ + "img/TUR-A-3-II.ab7417cf.png";